// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"_2VwFz","wrapper":"_3eQrR","title":"_3c13-"};